import React, {useState,useEffect} from 'react'
import axios from 'axios.js'
import { MatxLoading } from 'app/components'
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Icon,
    TablePagination,
    Button,
    TextField,
    MenuItem,
    Tooltip
} from '@material-ui/core';
import TypeOrderReceipt from "../../components/TypeOrderReceipt/TypeOrderPeceipt";
import GetTypeStatusReceipt from "../../components/TypeOrderReceipt/TypeStatusReceipt";
import GetTypeStatusOrder from "../../components/TypeOrderReceipt/TypeStatusPaymentOrder";
import GetReadyOrder from "../../components/TypeOrderReceipt/TypeReadyOrder";
import OrderProductListMini from "../../components/OrderProductListMini/OrderProductListMini";
// import {TpmOrderList} from "../../../redux/TmpStore";

import { makeStyles } from '@material-ui/core/styles';
import {TpmOrderListFastFood, TpmOrderListFastFood2, setDisplayListOrder} from "../../redux/TMPOrderListFastFood";
import useReferenceServerInfo from "../../hooks/useReferenceSystemServerInfo";
import GetTrueShow from "../../components/GetTrueShow/GetTrueShow";
import returnPhoneNumberFormat from "../../components/PhoneNumberFormat/returnPhoneNumberFormat";
import { getAllInvoice, deleteInvoice } from '../../views/invoice/InvoiceService'
import GetNameMonthUser from "../../components/GetNameMonthUser/GetNameMonthUser";
import {useHistory} from "react-router-dom";
import OrderExecutionIndicator from '../../components/OrderExecutionIndicator/OrderExecutionIndicator';


// console.log("Из файла - ",TpmOrderListFastFood());


const useStyles = makeStyles((theme) => ({
    root:{
        display:"none",
        "&.Active":{
            display:"table-row"
        }
    },
    afterShadow:{
        "&::after":{
            boxShadow: "0px 0px 15px 4px rgba(34, 60, 80, 0.2)",
            content:"1 ",
            width:"100%",
            height:"100%",
            position:"absolute"
        }
    },

    rootTextField:{
        "& .MuiInputBase-root": {
            fontSize: 12
        }
    },

    rootTextFieldAffiliates:{
        "& .MuiInputBase-root": {
            fontSize: 10
        }
    },
    repeatOrderButton: {
        color: theme.palette.primary.main,
        borderRadius: 6,
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}));

const KlientOrdersInfo = (
    {showType = "all",nowPage = 0, orderList = tmpOrder, statusReloadOrderListGlobal = 0,AllOrderServerGlobal=()=>{}, handleOpenDialogKlient = ()=>{}, onRepeatOrderNavigate = ()=>{}}
    ) => {
    const history = useHistory();
    const REPEAT_ORDER_STORAGE_KEY = 'pixelcrm_repeat_order';
    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [page, setPage] = React.useState(nowPage);
    const [loadingOrderList,setStatusLoadingOrderList] = React.useState(true);
    let [statusOrderList,setStatusOrderList] = React.useState(null);
    const {
        systemColor,
        referenceStatusOrderAll,
        referenceTypePaymentsAll,
        referenceNotesAll,
        affiliateAll,
        outletsAll,
        deletedOrderUser,
        referenceEmployeesList,
        setStatusOrderUser,
        setWorkerOrderUser,
        setTypePaymentOrder,
        referencePromoCreate,
        referencePromocode
    } = useReferenceServerInfo();
    const referenceColor = systemColor.StatusColor || [];
    const referenceColorMemo = systemColor.NotesColor || [];
    const referenceStatusAll = referenceStatusOrderAll || [];
    const [executionNow, setExecutionNow] = React.useState(Date.now());
    React.useEffect(() => {
        const timer = window.setInterval(() => setExecutionNow(Date.now()), 30000);
        return () => window.clearInterval(timer);
    }, []);
    const referenceEmploersAll = referenceEmployeesList || [];
    const referenceTypePaymentsAllList = referenceTypePaymentsAll || [];
    const [subscribarList,setSubcr] = React.useState([]);
    const promoListResolved = Array.isArray(referencePromoCreate?.promocode_list)
        ? referencePromoCreate.promocode_list
        : (Array.isArray(referencePromoCreate) ? referencePromoCreate : (Array.isArray(referencePromocode) ? referencePromocode : []));
    const promoCodeById = (promoIdRaw) => {
        const promoId = Number(promoIdRaw || 0);
        if (promoId <= 0) return "";
        const found = (promoListResolved || []).find((p) => Number(p?.id || p?.id_promocode || 0) === promoId);
        return found?.promocode || found?.code || "";
    };


    const [invoiceList, setInvoiceList] = useState([])
    const [invoice, setInvoice] = useState(null)
    const [open, setOpen] = useState(false)
    const [isAlive, setIsAlive] = useState(true)

    let activeOrder = '';
    console.log('что есть в orderList',subscribarList)
    const OrderListFilter=subscribarList.filter((order)=> activeOrder == order.id);


    // console.log("Приняли StatusColor и referenceStatusOrder", referenceColor,referenceStatusAll)
    const statusOrderColor = (idStatus = null) =>{
        if(idStatus == null){
            // console.log('IdStatus заказа, для которого нужно получить цвет = ',idStatus)
            return referenceColor[0].color;
        }
        let returnColor = false;

        referenceStatusAll.map((d,n)=>{
            if(idStatus == d.id){
                referenceColor.map((v,num)=>{
                    if(d.color == v.id){
                        // console.log('Данные цвета id которого получил совпадения ',v);

                        // if(d.activity == true & v.active == true) {
                        returnColor = v.color;
                        // }
                    }
                })
            }
        });

        if(returnColor === false){
            return referenceColor[0].color
        }else{
            return returnColor;
        }
    }


    const statusMemoColor = (idStatus = null) =>{
        if(idStatus == null){
            return referenceColorMemo[0].color;
        }
        let returnColor = false;

        referenceNotesAll.map((d,n)=>{
            if(idStatus == d.id){
                referenceColorMemo.map((v,num)=>{
                    if(d.color == v.id){
                        // console.log('Данные цвета id которого получил совпадения ',v);

                        // if(d.activity == true & v.active == true) {
                        returnColor = v.color;
                        // }
                    }
                })
            }
        });

        if(returnColor === false){
            return referenceColorMemo[0].color
        }else{
            return returnColor;
        }
    }

    const textMemoColor = (idStatus = null) =>{
        let returnName = false;
        if(idStatus == null){
            return "Вместо idNotes передано ничего";
        }

        referenceNotesAll.map((d,n)=>{
            if(idStatus == d.id){
                // if(d.activity == true) {
                returnName = d.name;
                // }
            }
        });

        if(returnName === false){
            // console.log('статус не распознан данные такие: ', idStatus);
            return "Пометка не распознана"
        }else{
            return returnName;
        }
    }



    const statusOrderName = (idStatus = null) =>{
        let returnName = false;
        if(idStatus == null){
            return "Вместо idStatus передано ничего";
        }

        referenceStatusAll.map((d,n)=>{
            if(idStatus == d.id){
                // if(d.activity == true) {
                returnName = d.name;
                // }
            }
        });

        if(returnName === false){
            // console.log('статус не распознан данные такие: ', idStatus);
            return "Статус не распознан"
        }else{
            return returnName;
        }
    }

    const classes = useStyles();

    const [sortStatus,setSortStatus] = useState(0);
    const [sortWorker,setSortWorker] = useState(0);
    const [sortTypePayment,setSortTypePayment] = useState(0);
    const [sortAffiliate,setSortAffiliate] = useState(0);
    const [sortPoints,setSortPoints] = useState(0);


    const getAffiliateAndPointsOrderList = (affiliate = [], outlets = [])=>{

        let NewArray = [{id_affiliate:0,id_points:0,text:<div className="flex justify-between items-center w-full">
                <span>Все филиалы</span><span>Все точки</span></div>}];

        affiliate.forEach((item,ind)=> {
            NewArray.push({id_affiliate:item.id,id_points:0,text:<div className="flex justify-between items-center w-full">
                    <span>{item.name}</span><span>Все точки</span></div>})
            outlets.forEach((iO, iOn) => {
                if(item.id == iO.id_affiliate) {
                    NewArray.push({
                        id_affiliate: item.id,
                        id_points: iO.id,
                        text: <div className="flex justify-between items-center w-full">
                            <span style={{paddingRight:10}}>{item.name}</span><span>{iO.name}</span></div>
                    })
                }
            })
        });


        return NewArray.map((dd,nn)=>(
            <MenuItem
                id={"Affiliate_"+dd.id_affiliate+"_"+dd.id_points}
                key={"Affiliate_"+dd.id_affiliate+"_"+dd.id_points}
                value={"Affiliate_"+dd.id_affiliate+"_"+dd.id_points}
                onClick={(e) => {
                    setSortAffiliate(dd.id_affiliate);
                    setSortPoints(dd.id_points);
                }}
                style={{fontSize:10}}
            >
                {dd.text}
            </MenuItem>
        ));
    };

    // const GetAllStatusOrderList = async ()=>{
    //     const response = await axios.get('/api/order/getAllStatus');
    //     const { AllStatusOrder } = response.data;
    //     // console.log('Мы в середине выполнения',orderListServer);
    //
    //     await setStatusOrderList(response.data.AllStatusOrder);
    //     console.log('Список статусов с сервера', statusOrderList, response.data.AllStatusOrder);
    //
    //         // setSession(accessToken)
    //
    //     return true;
    // }


    const AllOrderServer = async ()=>{
        // console.log('Начали обновление заказов');
        // const response = await axios.post('/api/order/all');
        // const { orderListServer } = response.data;
        // console.log('Мы в середине выполнения',orderListServer);

        // let orderListUpdate = setDisplayListOrder(orderListServer.OrderList,showType);
        let orderListUpdate = await setDisplayListOrder(orderList.OrderList,showType);

        // console.log("Пробуем передать список через функцию ", TpmOrderListFastFood2(orderListServer.OrderList));
        // console.log("Что обновляем в список заказов юзера",orderListUpdate);

        await setSubcr(orderListUpdate);
        // await setStatusOrderList(orderListServer.AllStatusOrder);
        // console.log('Обновили список заказов',orderListUpdate);
        // console.log('Список статусов с сервера', statusOrderList, orderListServer);
        // setSession(accessToken)

        return true;
    }


    useEffect(()=>{ async function fetchData() {
        // await GetAllStatusOrderList();
        // setSubcr(TpmOrderListFastFood(showType));
        //await AllOrderServer();
        // console.log('СТАТУСЫ КОТОРЫЕ ДОЛЖНЫ ОБНОВИТЬСЯ - ',statusOrderList);
        //setStatusLoadingOrderList(false);

    }
        fetchData();
    },[showType]);


    useEffect(()=>{ async function fetchData() {
        //await GetAllStatusOrderList();
        // setSubcr(TpmOrderListFastFood(showType));
        await AllOrderServer();
        // console.log('СТАТУСЫ КОТОРЫЕ ДОЛЖНЫ ОБНОВИТЬСЯ - ',statusOrderList);
        setStatusLoadingOrderList(false);

    }
        fetchData();
    },[statusOrderList,orderList]);

    const handleShowTrHidden = async (event,numberOrder) => {
        let newSubscr = {...subscribarList};
        let ReturnAr = [];
        Object.keys(newSubscr).map((data,num)=>{
            if(newSubscr[data].number === numberOrder){
                newSubscr[data].showTrHidden = !newSubscr[data].showTrHidden;
            }
            ReturnAr.push(newSubscr[data]);
        });
        // console.log('Смотрим делаи заказа ',numberOrder);
        await setSubcr(ReturnAr);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    const styleTD = {
        "borderleftf":{
            borderLeft: "0px solid #2cb52c",
            background: "#9ff0ff",
            minWidth: "30px",
            textAlign: "center",
        },
        "borderleftd":{
            borderLeft: "0px solid #335bc3",
            background: "#fff993",
            minWidth: "30px",
            textAlign: "center",
        },
        "back_RED":{
            background:"#feeaff"
        }
    };

    const styleTR = {
        "back_RED":{
            background:"#feeaff"
        }
    };

    const PrintElem = (id)=>{
        let Element = document.getElementById(id);
        console.log(Element,id);
        var mywindow = window.open('', 'my div', 'height=800,width=1024');
        mywindow.document.write('<html><head><title>Накладная</title>');
        mywindow.document.write('<style>#print_doc { display: block; !important} table{border-collapse:collapse;} table tr:nth-child(1){border-bottom:none;} table tr{border-bottom:1px solid #c2c2c2;} table td{padding:10px 10px;}</style></head><body >');
        mywindow.document.write(Element.innerHTML);
        mywindow.document.write('</body></html>');
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10
        mywindow.print();
        mywindow.close();
        return true;
    };

    // return (
    //     <div className="w-full overflow-auto" key="AllOrderDiv">
    //         {!subscribarList ? <div>Заказов нет</div> : <div>{console.log('Заказы тут',subscribarList)}</div> }
    //     </div>
    // );

    const handeViewClick = (invoiceId) => {
        // history.push(`/invoice/${invoiceId}`)

        //Тут функция перехода на страницу, потом удалить
    }

    const handeDeleteClick = (invoice) => {
        setInvoice(invoice)
        setOpen(true)
    }

    const handleConfirmationResponse = async () => {
        // deleteInvoice(invoice).then((res) => {
        //     if (isAlive) {
        //         // setInvoiceList(res.data)
        //         setOpen(false)
        //     }
        // })

        // console.log('Согласились удалить заказ');
        setStatusLoadingOrderList(true);
        const statusDeleteOrder = await deletedOrderUser(invoice.id);
        if(statusDeleteOrder === "success"){
            console.log('успешно принят ответ от сервера');

            await AllOrderServerGlobal(statusReloadOrderListGlobal+1);
            setOpen(false);
            // setStatusLoadingOrderList(false);
        }else{
            console.log('Что то пошло не по плану!',statusDeleteOrder);
            setOpen(false);
        }

        //тут функция удаления при согласии

    }

    const GlobalUpdateOrderList = async ()=>{
        // console.log('Начали обновление списка заказов для глобального перерендера');
        setStatusLoadingOrderList(true);
        await AllOrderServerGlobal(statusReloadOrderListGlobal+1);
        // await AllOrderServer();
        setStatusLoadingOrderList(false);
    }

    const handleDialogClose = () => {
        setOpen(false)
    }

    const handleRepeatOrder = (order = null) => {
        if (!order) return;
        try {
            sessionStorage.setItem(REPEAT_ORDER_STORAGE_KEY, JSON.stringify(order));
            onRepeatOrderNavigate();
            history.push('/order/newOrderFastFood?repeatOrder=1');
        } catch (e) {
            console.error('Не удалось подготовить повтор заказа', e);
            alert('Не удалось подготовить повтор заказа');
        }
    };


    if (loadingOrderList) {
        return <MatxLoading />
    }

    const handleSetStatusOrder = async (idStatus,idOrder,orderList,statusList)=>{
        // console.log('Страые данные такие ',orderList);

        const OldData = [...orderList];
        let statusReloadStatusOrder = false;
        let NewStatusObject = {};
        statusList.map((d,n)=>{
            if(d.id == idStatus){
                statusReloadStatusOrder = true;
                NewStatusObject = {...d,...{id_status:d.id,id_worker:0,time_insert:Math.floor(Date.now()/1000)}};
            }
        });

        const NewData = statusReloadStatusOrder === true
            ? OldData.map((row) => (row.id == idOrder ? { ...row, statusOrder: { ...NewStatusObject } } : row))
            : OldData;
        // console.log('Что передаем в функцию смены статуса',idStatus,idOrder,statusList);
        // console.log('новые данные такие ',NewData);
        const result = await setStatusOrderUser(idOrder,idStatus);
        if (result === 'success' || result?.result === 'success' || result?.data?.result === 'success') setSubcr(NewData);

    }


    const handleSetWorkerStatusOrder = async (idStatus,idOrder,idWorker,orderList,statusList)=>{
        // console.log('Страые данные такие ',orderList);

        let OldData = [...orderList];
        let statusReloadStatusOrder = false;
        let NewStatusObject = {};
        statusList.map((d,n)=>{
            if(d.id == idStatus){
                statusReloadStatusOrder = true;
                NewStatusObject = {...d,...{id_status:d.id,id_worker:idWorker}};
            }
        });

        if(statusReloadStatusOrder === true){
            OldData.map((dd,nn)=>{
                if(dd.id == idOrder){
                    OldData[nn].statusOrder = {...NewStatusObject};
                }
            });
        }
        let NewData = OldData;
        // console.log('Что передаем в функцию смены статуса',idStatus,idOrder,statusList);
        // console.log('новые данные такие ',NewData);
        setSubcr(NewData);

        await setWorkerOrderUser(idOrder,idStatus,idWorker);

    }


    const handleSetTypePaymentOrder = async (idOrder,idPayment,orderList,typePaymentList,typePaymentOrderName = ()=>{})=>{
        // console.log('Страые данные такие ',orderList);


        let OldData = [...orderList];
        let statusReloadStatusOrder = false;
        let NewStatusObject = {};

        typePaymentList.map((d,n)=>{
            if(d.id == idPayment){
                statusReloadStatusOrder = true;
                NewStatusObject = idPayment;
            }
        });

        if(idPayment == 0){
            statusReloadStatusOrder = true;
            NewStatusObject = idPayment;

            // console.log('Передан нулевой id для типа оплаты',idPayment);
        }


        if(statusReloadStatusOrder === true){
            OldData.map((dd,nn)=>{
                if(dd.id == idOrder){
                    OldData[nn].orderData.typePayment = NewStatusObject;
                }
            });
        }

        let textTypePayment = typePaymentOrderName(idPayment,true);

        let NewData = OldData;
        // // console.log('Что передаем в функцию смены статуса',idStatus,idOrder,statusList);
        // console.log('новые данные такие ',NewData);
        setSubcr(NewData);
        // console.log('Переданем в API',idOrder,idPayment,textTypePayment);

        await setTypePaymentOrder(idOrder,idPayment,textTypePayment);

    }

    const typePaymentOrderName = (idStatus,status = false)=>{
        let returnName = false;
        if(idStatus == null){
            return "Вместо idStatus передано ничего";
        }

        referenceTypePaymentsAllList.map((d,n)=>{
            if(idStatus == d.id){
                // if(d.activity == true) {
                returnName = d.name;
                // }
            }
        });

        if(returnName === false){
            // console.log('статус не распознан данные такие: ', idStatus);
            if(status){
                return "";
            }else {
                return "Тип оплаты не распознан";
            }
        }else{
            return returnName;
        }
    }

    const getAllOrderSorts = (allOrder = [])=>{

        // console.log('Нужно отсортировать вот это ',allOrder);

        let SortStatus = [];
        let SortWorker = [];
        let SortPaymentTypeList = [];
        let SortAffiliateList = [];
        let SortPointsList = [];

        let returnOrderSorts = [];

        allOrder.map((d,n)=>{
            if(sortStatus != 0){
                if(d.statusOrder.id_status == sortStatus){
                    SortStatus.push(d);
                }
            }else{
                SortStatus.push(d);
            }
        });


        SortStatus.map((d,n)=>{
            if(sortWorker != 0){
                switch (sortWorker) {
                    case "-1":
                        if(d.statusOrder.id_worker != 0){
                            SortWorker.push(d);
                        }
                        break;
                    case "-2":
                        if(d.statusOrder.id_worker == 0){
                            SortWorker.push(d);
                        }
                        break;
                    default:
                        if(d.statusOrder.id_worker == sortWorker){
                            SortWorker.push(d);
                        }
                }
            }else{
                SortWorker.push(d);
            }
        });


        SortWorker.map((d,n)=>{
            if(sortTypePayment != 0){
                if(d.orderData.typePayment == sortTypePayment){
                    SortPaymentTypeList.push(d);
                }
            }else{
                SortPaymentTypeList.push(d);
            }
        });


        SortPaymentTypeList.map((d,n)=>{
            if(sortAffiliate != 0){
                if(d.delivered.id_affiliate == sortAffiliate){
                    SortAffiliateList.push(d);
                }
            }else{
                SortAffiliateList.push(d);
            }
        });



        SortAffiliateList.map((d,n)=>{
            if(sortPoints != 0){
                if(d.delivered.pointOrderId == sortPoints){
                    SortPointsList.push(d);
                }
            }else{
                SortPointsList.push(d);
            }
        });

        console.log("Отсортированный массив с заказами ",SortPointsList);

        return SortPointsList;

    }

    const sortTableStatus = ()=>{
        return (
            <TextField
                defaultValue={sortStatus}
                variant="outlined"
                size="small"
                select
                value={sortStatus}
                onChange={(e)=>setSortStatus(e.target.value)}
                //Сюда подставить цвета
                // style={{backgroundColor:statusOrderColor(status) || "#eeeeee",minWidth:"150px",textAlign:"center"}}
                style={{backgroundColor:"#ffffff",minWidth:"150px",textAlign:"center",borderRadius:4}}
            >
                <MenuItem
                    disabled={true}
                    key={"MenuItemStatusOrderSorts_0"}
                    style={{backgroundColor: "#ffffff"}}
                    value={0}>Все статусы</MenuItem>
                {referenceStatusAll.map(
                    (d,n)=>{
                        if(GetTrueShow([
                            [d.activity,true],
                            [d.deleted,false]
                        ])) {
                            return (
                                <MenuItem disabled={true} style={{backgroundColor: statusOrderColor(d.id)}}
                                          key={"Status_MenuItem_"+d.id}
                                          value={d.id}>{statusOrderName(d.id)}</MenuItem>)
                        }else{
                            return (
                                <MenuItem disabled={true} style={{backgroundColor: statusOrderColor(d.id),display:"none"}}
                                          key={"Status_MenuItem_"+d.id}
                                          value={d.id}>{statusOrderName(d.id)}</MenuItem>)
                        }
                    }

                )}
            </TextField>
        )
    }

    const sortTableTypePayment = ()=>{
        return (
            <TextField
                defaultValue={sortTypePayment}
                variant="outlined"
                size="small"
                select
                value={sortTypePayment}
                onChange={(e)=>setSortTypePayment(e.target.value)}
                //Сюда подставить цвета
                style={{minWidth:90,maxWidth:100}}
                className={
                    classes.rootTextField
                }
            >
                <MenuItem
                    key={"MenuItemPaymentsTypeOrderSorts_0"}
                    style={{backgroundColor: "#ffffff"}}
                    value={0}>Оплата</MenuItem>
                {referenceTypePaymentsAllList.map(
                    (d,n)=>{

                        // console.log(subscriber);

                        if(GetTrueShow([
                            [d.activity,true],
                            [d.deleted,false]
                        ])) {
                            return (
                                <MenuItem
                                    value={d.id}
                                    key={"Type_paymentMenuItem_"+d.id}
                                >
                                    {typePaymentOrderName(d.id)}
                                </MenuItem>
                            )
                        }else{
                            return (
                                <MenuItem
                                    disabled={true}
                                    style={{display:"none"}}
                                    key={"Type_paymentMenuItem_"+d.id}
                                    value={d.id}
                                >
                                    {typePaymentOrderName(d.id)}
                                </MenuItem>
                            )
                        }
                    }

                )}
            </TextField>
        )
    }

    const sortTableWorker = ()=>{
        return (
            <TextField
                defaultValue={sortWorker}
                variant="outlined"
                size="small"
                select
                value={sortWorker}
                onChange={(e)=>setSortWorker(e.target.value)}
                //Сюда подставить цвета
                // style={{backgroundColor:statusOrderColor(status) || "#eeeeee",minWidth:"150px",textAlign:"center"}}
                style={{backgroundColor:"#ffffff",minWidth:"150px",textAlign:"center",borderRadius:4}}
            >
                <MenuItem
                    key={"TWorkerSortsMenuItem_0"}
                    value="0">Все сотрудники</MenuItem>
                <MenuItem
                    key={"TWorkerSortsMenuItem__1"}
                    value="-1">С сотрудником</MenuItem>
                <MenuItem key={"TWorkerSortsMenuItem__2"}
                          value="-2">Без сотрудников</MenuItem>
                {/*{console.log('Тут ругаемся на что то, на что не понятно = ',referenceEmploersAll)}*/}
                {referenceEmploersAll.length > 0 ? referenceEmploersAll.map(
                    (d,n)=>{
                        if(GetTrueShow([
                            [d.activity,true],
                            [d.deleted,false],
                            [d.orderSet,true]
                        ])) {
                            return (
                                <MenuItem
                                    key={"TWorkerSortsMenuItem_"+d.id}
                                    disabled={true} value={d.id} key={"WorkerMenuItem_"+d.id}>{d.name}</MenuItem>
                            )
                        }else{
                            return (
                                <MenuItem
                                    key={"TWorkerSortsMenuItem_"+d.id}
                                    disabled={true} key={"WorkerMenuItem_"+d.id} style={{display:"none"}}
                                    value={d.id}>{d.name}</MenuItem>)
                        }
                    }
                ) : false}
            </TextField>
        )
    }

    return (
        <div className="w-full overflow-auto" key="AllOrderDiv_Sorts">
            {!subscribarList ? "" :
                <Table className="whitespace-pre" key="AllOrderTables_SortTable" size="small"
                       style={{borderCollapse:"separate",padding:"0 4px"}}>
                    <TableHead key="AllOrderTablesHead_Sorts">
                        <TableRow key="AllOrderTablesRow_Sorts">
                            <TableCell className="px-0 align-content-center" align="center" size="small" style={{fontWeight:"bold",width:"10%",minWidth:"130px",border:"none"}}>

                                {/*<TextField*/}
                                {/*    select*/}
                                {/*    fullWidth*/}
                                {/*    variant="outlined"*/}
                                {/*    size="small"*/}
                                {/*    name={"sortAffiliateAndPoints"}*/}
                                {/*    style={{maxWidth:"100%"}}*/}
                                {/*    value={"Affiliate_"+sortAffiliate+"_"+sortPoints+""}*/}
                                {/*    className={*/}
                                {/*        classes.rootTextFieldAffiliates*/}
                                {/*    }*/}
                                {/*    // onChange={(e)=>{console.log("ЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯЛЯ = ",e.target.value)}}*/}
                                {/*>*/}

                                {/*    {getAffiliateAndPointsOrderList(affiliateAll,outletsAll)}*/}
                                {/*</TextField>*/}

                            </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"10%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"7%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"6%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"9%",border:"none"}}> </TableCell>
                            {/*<TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"10%",border:"none"}}>Клиент</TableCell>*/}
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"25%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="right" style={{fontWeight:"bold",width:"18%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"13%",border:"none"}}> </TableCell>
                            <TableCell className="px-0" align="center" style={{fontWeight:"bold",width:"4%",minWidth:"56px",border:"none"}}> </TableCell>
                        </TableRow>
                    </TableHead>
                    {getAllOrderSorts(subscribarList)
                        .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                        )
                        .map((subscriber, index) => {
                            console.log("Что в заказе который не выводится ",subscriber)
                            const dateOrderDelivered = new Date(subscriber.delivered.dateDelivered);
                            const dateSetOrder = new Date(subscriber.delivered.dateSetOrder);

                            // console.log("Заказ для отправки на сервер - ",JSON.stringify(subscriber));

                            const dateDelivered = ()=>{
                                let date = dateOrderDelivered.getDate()
                                if(dateOrderDelivered.getDate()<10){
                                    date = '0'+date;
                                }

                                return (date+' '+(GetNameMonthUser(dateOrderDelivered.getMonth(),false,1,0))+' '+dateOrderDelivered.getFullYear());
                            };


                            const getDateSetOrder = ()=>{
                                let date = dateSetOrder.getDate()
                                if(dateSetOrder.getDate()<10){
                                    date = '0'+date;
                                }

                                return (date+' '+(GetNameMonthUser(dateSetOrder.getMonth(),false,1,0))+' '+dateSetOrder.getFullYear()+' в '+dateSetOrder.getHours()+':'+dateSetOrder.getMinutes());
                            };

                            const getTypeDeliveredOrder = (type)=>{
                                let typeText = "Способ получения не определен";

                                switch (type) {
                                    case "0": typeText = "Доставка";break;
                                    case 0: typeText = "Доставка";break;
                                    case false: typeText = "Доставка";break;
                                    case "1": typeText = "Самовывоз";break;
                                    case 1: typeText = "Самовывоз";break;
                                    case true: typeText = "Самовывоз";break;
                                }

                                return typeText;
                            };

                            const getTimeDeliveredType = (type)=>{
                                let typeText = "Тип получения не определен";

                                switch (type) {
                                    case "0": typeText = "На текущее";break;
                                    case 0: typeText = "На текущее";break;
                                    case false: typeText = "На текущее";break;
                                    case "1": typeText = "Предзаказ";break;
                                    case 1: typeText = "Предзаказ";break;
                                    case true: typeText = "Предзаказ";break;
                                }

                                return typeText;
                            };

                            const getMemoCard = (memo)=>{
                                const typeSetOrder = memo?.typeSetOrder || false;

                                let visualMemoCard = "";

                                if(typeSetOrder !== false){
                                    visualMemoCard = typeSetOrder.map((d,n)=>{
                                        // console.log('-1-1-1-1-1-1-11-1-1-11-',d);
                                        return getCardMemo(textMemoColor(d.id_notice),statusMemoColor(d.id_notice));
                                    });
                                }


                                return visualMemoCard;
                            };

                            const getMemoCardexpired = (order)=>(
                                <OrderExecutionIndicator
                                    order={order}
                                    statuses={referenceStatusAll}
                                    nowMs={executionNow}
                                    style={{margin:"2px 6px"}}
                                />
                            );

                            const getCardMemo = (text,color)=>{
                                // console.log('textextextextext ---- -',text);
                                return (<div style={{padding:"2px 8px",borderRadius:10,border:"1px solid "+color,color:color,fontSize:12, width:"auto", margin:"2px 6px",fontWeight:"500"}}>{text}</div>);
                            };

                            const getProductListOrder = (products) =>{

                                const productList = products.filter((row) => !String(row?.localId || row?.local_id || '').endsWith('_no_print')).map((data,number)=>{
                                    const price = Number(data?.price || 0);
                                    const originalPriceRaw = data?.originalPrice !== undefined && data?.originalPrice !== null
                                        ? data.originalPrice
                                        : data?.original_price;
                                    const originalPrice = originalPriceRaw !== undefined && originalPriceRaw !== null
                                        ? Number(originalPriceRaw)
                                        : null;
                                    const hasOldPrice = originalPrice !== null && originalPrice > price;
                                    return(
                                        <tr key={"ProductListTR_"+data.id}>
                                            <td key={"ProductListChildTable_td1_"+data.id} style={{textAlign:"left",width:"70%",lineHeight:"13px"}}>{data.title}</td>
                                            <td key={"ProductListChildTable_td2_"+data.id}style={{width:"10%",textAlign:"right",lineHeight:"13px"}}>{data.count}</td>
                                            <td key={"ProductListChildTable_td3_"+data.id}style={{textAlign:"right",lineHeight:"13px"}}>
                                                {hasOldPrice ? (
                                                    <div style={{display:"inline-flex", flexDirection:"column", alignItems:"flex-end", lineHeight:1}}>
                                                        <span style={{textDecoration:"line-through", opacity:0.6, fontSize:"11px", marginBottom:"-2px"}}>{originalPrice} ₽</span>
                                                        <span>{price} ₽</span>
                                                    </div>
                                                ) : (
                                                    <span>{price} ₽</span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                });

                                return (<div className="flex justify-content-between align-content-center ">
                                    <table width="100%"><thead></thead><tbody>{productList}</tbody></table>
                                </div>)
                            };

                            const getKlietnInfo = (klient) =>{

                                return (
                                    <div>
                                        <div>
                                            {klient?.firstName || false}
                                        </div>
                                        <div style={{cursor:"pointer"}} onClick={()=> handleOpenDialogKlient(klient.id)}>
                                            {returnPhoneNumberFormat(klient?.phone) || false}
                                        </div>
                                    </div>
                                );
                            };

                            const getAddressInfo = (delivered) =>{

                                if("adres" in delivered){
                                    if(delivered.adres !== false){
                                        return (
                                            <div style={{textAlign:"left"}}>
                                                <div>{delivered.adres.city}, {delivered.adres.street}, {delivered.adres.home}, {delivered.adres.apartament}</div>
                                                <div style={{fontSize:12,color:"#999999"}}>{delivered.adres.comment}</div>
                                            </div>
                                        )}else{
                                        return false;
                                    }
                                }else{
                                    return false;
                                }
                            };


                            const getMarksOrder = (marks) => {

                                if(!marks || marks?.length <=0){
                                    return false;
                                }

                                const listMarks = marks.map((data,number)=>{
                                    return (
                                        <div style={{
                                            padding:"2px 10px",
                                            backgroundColor:"#fafafa",
                                            color:"#313131",
                                            border:"1px solid #eeeeee",
                                            borderRadius:"10px",
                                            margin:"2px 4px",
                                            // width:"99%",
                                            boxSizing:"box-size",
                                            display:"inline-block",
                                            fontSize:11
                                        }}>{data.name}</div>
                                    )
                                });

                                return (<div className="flex" style={{justifyContent:"flex-end",flexWrap:"wrap"}}>{listMarks}</div>)
                            };

                            // По идее меню Статусы и сотрудники для заказов что не нужны тут
                            const getStatusOrder = (worker = 0, status = 1, type = 0)=>{
                                //Сюда нужно передавать список работников+ кто назначен на текущий статус.
                                //Далее список статусов + какой статус назначен
                                //А так же в списке статусов их цветовое отображение

                                if(type === 0){
                                    return (
                                        <TextField
                                            defaultValue={worker}
                                            variant="outlined"
                                            size="small"
                                            select
                                            value={worker}
                                            disabled={true}
                                            onChange={(e)=>handleSetWorkerStatusOrder(status,subscriber.id,e.target.value,subscribarList,referenceStatusAll)}
                                            style={{backgroundColor:"#ffffff",minWidth:"100px",textAlign:"center",borderRadius:"4px"}}
                                        >
                                            <MenuItem disabled={true} value="0">Не выбран</MenuItem>
                                            {/*{console.log('Тут ругаемся на что то, на что не понятно = ',referenceEmploersAll)}*/}
                                            {referenceEmploersAll.length > 0 ? referenceEmploersAll.map(
                                                (d,n)=>{
                                                    if(GetTrueShow([
                                                        [d.activity,true],
                                                        [d.deleted,false],
                                                        [d.orderSet,true]
                                                    ])) {
                                                        return (
                                                            <MenuItem disabled={true} value={d.id}  key={"Emploers_MenuItem_"+d.id}>{d.name}</MenuItem>
                                                        )
                                                    }else{
                                                        return (
                                                            <MenuItem key={"Emploers_MenuItem_"+d.id} disabled={true} style={{display:"none"}}
                                                                      value={d.id}>{d.name}</MenuItem>)
                                                    }
                                                }
                                            ) : false}
                                        </TextField>
                                    );
                                }else{
                                    return (
                                        <TextField
                                            defaultValue={status}
                                            variant="outlined"
                                            size="small"
                                            select
                                            value={status}
                                            disabled={true}
                                            onChange={(e)=>handleSetStatusOrder(e.target.value,subscriber.id,subscribarList,referenceStatusAll)}
                                            //Сюда подставить цвета
                                            // style={{backgroundColor:statusOrderColor(status) || "#eeeeee",minWidth:"150px",textAlign:"center"}}
                                            style={{backgroundColor:"#ffffff",minWidth:"100px",textAlign:"center",borderRadius:4}}
                                        >
                                            {referenceStatusAll.map(
                                                (d,n)=>{
                                                    if(GetTrueShow([
                                                        [d.activity,true],
                                                        [d.deleted,false]
                                                    ])) {
                                                        return (
                                                            <MenuItem disabled={true} key={"StatusOrder__MenuItem_"+d.id} style={{backgroundColor: statusOrderColor(d.id)}}
                                                                      value={d.id}>{statusOrderName(d.id)}</MenuItem>)
                                                    }else{
                                                        return (
                                                            <MenuItem disabled={true} key={"StatusOrder__MenuItem_"+d.id} style={{backgroundColor: statusOrderColor(d.id),display:"none"}}
                                                                      value={d.id}>{statusOrderName(d.id)}</MenuItem>)
                                                    }
                                                }

                                            )}
                                            {/*<MenuItem value="1">Новый</MenuItem>*/}
                                            {/*<MenuItem value="2">В производстве</MenuItem>*/}
                                            {/*<MenuItem value="3">На баре</MenuItem>*/}
                                            {/*<MenuItem value="4">В пути</MenuItem>*/}
                                            {/*<MenuItem value="5">Выполнен</MenuItem>*/}
                                            {/*<MenuItem value="6">Списан</MenuItem>*/}
                                        </TextField>
                                    )
                                }


                            };



                            const getAffiliateDataOrder = (data)=>{
                                // console.log(data.id_affiliate);
                                let nameAffiliate = "Филиал не определен!";

                                let affiliateList = affiliateAll || [];

                                affiliateList.map((d,n)=>{
                                    if(d.id == data.delivered.id_affiliate){
                                        nameAffiliate = d.name;
                                    }
                                });

                                return nameAffiliate;
                            };


                            const getOutletsDataOrder = (data)=>{
                                // console.log(data.id_affiliate);
                                let nameOutlets = "Торговая точка не определена!";

                                let OutletsList = outletsAll || [];


                                // console.log('Список торговых точек такой = ',OutletsList, data.delivered.pointsOrderId);

                                OutletsList.map((d,n)=>{
                                    if(d.id == data.delivered.pointOrderId){
                                        nameOutlets = d.name;
                                    }
                                });

                                return nameOutlets;
                            };



                            const getSumOrderVisual = (data)=>{
                                let ReturnVisual = '';

                                if(data.ItogSumOrderNoDiscount != data.ItogSumOrder){
                                    ReturnVisual = <div key={"sumItodDiv"}><div style={{fontSize:12,color:"#eeeeee"}}><s>{data.ItogSumOrderNoDiscount} ₽</s></div>
                                        <div>{data.ItogSumOrder} ₽</div>
                                    </div>;
                                }else{
                                    ReturnVisual = <div key={"sumItodDiv"}>{data.ItogSumOrder} ₽</div>;
                                }

                                return ReturnVisual;
                            };

                            //////////////////////////////////////////////////////


                            return (
                                <><TableBody key={"Orders_Date_TB"+index}
                                             style={
                                                 {boxShadow: "0px 0px 6px -2px #eeeeee"}
                                             }>
                                    {subscriber.statusOrder === 'Заказы отсутствуют' ? false :
                                        <>
                                            <TableRow key={"Orders_Date_TRR_"+index}
                                                      style={{
                                                          backgroundColor: statusOrderColor(subscriber.statusOrder.id_status) || "#ffffff",
                                                          borderRadius:"10px 10px 0 0",
                                                          border:"none",
                                                          // boxShadow: "0px 0px 15px 4px rgba(34, 60, 80, 0.2)"
                                                      }}
                                                      className={classes.afterShadow}
                                            >
                                                <TableCell
                                                    className="px-0 pl-2"
                                                    align="left"
                                                    // size="small"
                                                    style={{fontSize:14,paddingLeft:"6px",paddingTop:"2px",paddingBottom:"2px"}}
                                                    key={"Cell_Number_Date_Deleivered"+index}
                                                    colSpan={6}
                                                >
                                                    <div className="flex justify-content-between align-content-between" style={{justifyContent:"space-between",alignItems:"center"}}>
                                                        <div className="flex justify-content-between align-content-between" style={{flexWrap:"wrap",alignItems:"center"}}>
                                                            <div style={{marginRight:"3px"}}>
                                                                <span style={{paddingRight:"8px"}}><b>{subscriber.delivered.timeDeliveredText}</b></span>
                                                                <span style={{paddingRight:"8px"}}>{dateDelivered()}</span>
                                                                <span style={{paddingRight:"8px"}}>№{subscriber.numberOrder || subscriber.number_order || subscriber.id}</span>
                                                            </div>
                                                            <div style={{marginRight:"12px"}}>
                                                                {getTypeDeliveredOrder(subscriber.delivered.typeDeliveredOrder)} к <b>{subscriber.delivered.timeDeliveredText}</b>
                                                            </div>
                                                            <div>
                                                                {subscriber.delivered.timeDeliveredType == 1 ?
                                                                    <i style={{fontSize:"12px"}}>{getTimeDeliveredType(subscriber.delivered.timeDeliveredType)+" от "+getDateSetOrder()}</i>
                                                                    :
                                                                    false
                                                                }
                                                            </div>

                                                            <div className="flex justify-content-start align-content-between">{getMemoCard(subscriber.memo)} {getMemoCardexpired(subscriber)}</div>

                                                        </div>
                                                    </div>
                                                </TableCell>

                                                <TableCell
                                                    className="px-0"
                                                    align="left"
                                                    // size="small"
                                                    style={{fontSize:14,paddingLeft:"6px",paddingTop:"2px",paddingBottom:"2px"}}
                                                    key={"Cell_Number_OrderStatus_"+index}
                                                    colSpan={1}
                                                >
                                                    <div className="flex justify-end items-center" style={{alignItems:"center"}}>
                                                        {getStatusOrder(subscriber.statusOrder.id_worker,subscriber.statusOrder.id_status,0)}
                                                    </div>
                                                </TableCell>

                                                <TableCell
                                                    className="px-0"
                                                    align="left"
                                                    // size="small"
                                                    style={{fontSize:14,paddingLeft:"6px",paddingTop:"2px",paddingBottom:"2px"}}
                                                    key={"Cell_Number_OrderStatus_2_"+index}
                                                    colSpan={1}
                                                >
                                                    <div className="flex justify-center items-center" style={{alignItems:"center"}}>
                                                        {getStatusOrder(subscriber.statusOrder.id_worker,subscriber.statusOrder.id_status,1)}
                                                    </div>
                                                </TableCell>

                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                    // size="small"
                                                    style={{fontSize:14,paddingLeft:0,paddingRight:0,verticalAlign:"middle",minWidth:"56px",paddingTop:"2px",paddingBottom:"2px"}}
                                                    key={"Cell_Number_Order_Info_"+index}
                                                    colSpan={1}
                                                >
                                                    <div className="flex justify-center items-center" style={{width:"100%"}}>
                                                        <Tooltip title="Повторить заказ" arrow placement="left">
                                                            <IconButton
                                                                size="medium"
                                                                className={classes.repeatOrderButton}
                                                                onClick={() => handleRepeatOrder(subscriber)}
                                                            >
                                                                <Icon fontSize="small">replay</Icon>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                            <TableRow key={"Orders_Info_"+index}
                                                      style={{backgroundColor: "#ffffff",borderRadius:"10px 10px 0 0",border:"none"}}

                                            >
                                                <TableCell
                                                    className="px-0 pl-2"
                                                    align="center"
                                                    // size="small"
                                                    style={{
                                                        overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                                                        wordWrap: "normal",
                                                        wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                                                        lineBreak: "auto",  /* нет поддержки для русского языка */
                                                        hyphens: "manual",  /* значение auto не поддерживается Chrome */
                                                        fontSize:12,
                                                        textTransform:"none",
                                                        border:"none"
                                                    }}
                                                    key={"Cell_Number_Product_list"+index}
                                                    colSpan={2}
                                                >
                                                    {getProductListOrder(subscriber.products)}
                                                </TableCell>
                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                    style={{
                                                        overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                                                        wordWrap: "normal",
                                                        wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                                                        lineBreak: "auto",  /* нет поддержки для русского языка */
                                                        hyphens: "manual",  /* значение auto не поддерживается Chrome */
                                                        fontSize:12,
                                                        border:"none"
                                                    }}
                                                    key={"Cell_name_SUM_"+index}

                                                >
                                                    <div style={{padding:"0 6px"}}>
                                                        {getSumOrderVisual(subscriber)}
                                                        {/*{subscriber.ItogSumOrder} ₽*/}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                    style={{
                                                        overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                                                        wordWrap: "normal",
                                                        wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                                                        lineBreak: "auto",  /* нет поддержки для русского языка */
                                                        hyphens: "manual",  /* значение auto не поддерживается Chrome */
                                                        fontSize:12,
                                                        border:"none"
                                                    }}
                                                    key={"Cell_name_Sum_Discount_"+index}

                                                >
                                                    <div style={{padding:"0 6px"}}>
                                                        {!!Number(subscriber?.orderData?.promokodeId || 0) && (
                                                            <div style={{display:"flex", alignItems:"center", justifyContent:"center", gap:4, fontSize:11, color:"#6b7280", marginBottom:2}}>
                                                                <Icon style={{fontSize:12}}>confirmation_number</Icon>
                                                                <span>
                                                                    {subscriber?.orderData?.promokode
                                                                        || subscriber?.orderData?.promokodeCode
                                                                        || subscriber?.orderData?.promoCode
                                                                        || promoCodeById(subscriber?.orderData?.promokodeId)
                                                                        || `#${Number(subscriber?.orderData?.promokodeId || 0)}`}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {subscriber.sumDiscountOrder} ₽
                                                    </div>
                                                </TableCell>



                                                {/*<TableCell*/}
                                                {/*    className="px-0"*/}
                                                {/*    align="center"*/}
                                                {/*    style={{*/}
                                                {/*        overflowWrap: "normal",  // не поддерживает IE, Firefox; является копией word-wrap /*/}
                                                {/*        wordWrap: "break-word",*/}
                                                {/*        wordBreak: "normal",  // не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome /*/}
                                                {/*        lineBreak: "auto",  // нет поддержки для русского языка /*/}
                                                {/*        hyphens: "manual",  // значение auto не поддерживается Chrome /*/}
                                                {/*        fontSize:13,*/}
                                                {/*        border:"none"*/}
                                                {/*    }}*/}
                                                {/*    key={"Cell_name_"+index}*/}

                                                {/*>*/}
                                                {/*    <div style={{padding:"0 10px"}}>*/}
                                                {/*        {getKlietnInfo(subscriber.klient)}*/}
                                                {/*    </div>*/}
                                                {/*</TableCell>*/}
                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                    colSpan={2}
                                                    style={{
                                                        overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                                                        wordWrap: "normal",
                                                        wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                                                        lineBreak: "auto",  /* нет поддержки для русского языка */
                                                        hyphens: "manual",  /* значение auto не поддерживается Chrome */
                                                        fontSize:12,
                                                        border:"none"
                                                    }}
                                                    key={"Cell_name_Address_Info_"+index}

                                                >
                                                    <div style={{padding:"0 6px"}}>
                                                        {getAddressInfo(subscriber.delivered)}
                                                    </div>
                                                </TableCell>

                                                <TableCell
                                                    className="px-0"
                                                    align="center"
                                                    colSpan={2}
                                                    style={{
                                                        overflowWrap: "normal",  /* не поддерживает IE, Firefox; является копией word-wrap */
                                                        wordWrap: "normal",
                                                        wordBreak: "normal",  /* не поддерживает Opera12.14, значение keep-all не поддерживается IE, Chrome */
                                                        lineBreak: "auto",  /* нет поддержки для русского языка */
                                                        hyphens: "manual",  /* значение auto не поддерживается Chrome */
                                                        fontSize:12,
                                                        border:"none"
                                                    }}
                                                    key={"Cell_name_Comment_Order"+index}

                                                >
                                                    <div style={{padding:"0 6px"}}>
                                                        {subscriber.orderData.comment}
                                                    </div>
                                                </TableCell>

                                                {/*<TableCell className="px-0"*/}
                                                {/*           align="center"*/}
                                                {/*           key={"Cell_Icon_"+index}*/}
                                                {/*           style={{border:"none"}}*/}
                                                {/*>*/}
                                                {/*    /!*<IconButton size="small" onClick={*!/*/}
                                                {/*    /!*    (e)=>{*!/*/}
                                                {/*    /!*        console.log("Нажали на детали заказа ",index);*!/*/}
                                                {/*    /!*        // handleShowTrHidden(e,subscriber.number)*!/*/}
                                                {/*    /!*    }*!/*/}
                                                {/*    /!*}>*!/*/}
                                                {/*    /!*    <Icon color="disabled" style={{ fontSize: 31 }}>{subscriber.showTrHidden === false ? "expand_more" : "expand_less"}</Icon>*!/*/}
                                                {/*    /!*</IconButton >*!/*/}
                                                {/*    /!*<IconButton >*!/*/}
                                                {/*    /!*    <Icon color="disabled" style={{ fontSize: 21 }}>edit</Icon>*!/*/}
                                                {/*    /!*</IconButton>*!/*/}
                                                {/*    /!*<IconButton size="small"*!/*/}
                                                {/*    /!*            onClick={()=>handeDeleteClick(subscriber)}*!/*/}
                                                {/*    /!*            // onClick={()=>GlobalUpdateOrderList()}*!/*/}
                                                {/*    /!*>*!/*/}
                                                {/*    <Icon color="error" style={{ fontSize: 24 }} onClick={()=>handeDeleteClick(subscriber)}>close</Icon>*/}
                                                {/*    /!*</IconButton>*!/*/}
                                                {/*</TableCell>*/}
                                            </TableRow>
                                            <TableRow key={"Orders_Date_TYRT_"+index}
                                                      style={{
                                                          backgroundColor: "#ffffff",
                                                          borderRadius:"10px 10px 0 0",
                                                          border:"none",
                                                          // boxShadow: "0px 0px 15px 4px rgba(34, 60, 80, 0.2)"
                                                      }}
                                                      className={classes.afterShadow}
                                            >
                                                <TableCell
                                                    className="px-0 pl-2"
                                                    align="left"
                                                    // size="small"
                                                    style={{fontSize:12,paddingLeft:"6px",paddingTop:"4px",paddingBottom:"4px",borderTop:"1px solid #eeeeee",borderBottom:0}}
                                                    key={"Cell_Number_Affiliate_list_"+index}
                                                    colSpan={10}
                                                >
                                                    <div className="flex justify-content-between align-content-between" style={{justifyContent:"space-between",alignItems:"center"}}>
                                                        <div className="flex justify-content-between align-content-between" style={{flexWrap:"wrap",alignItems:"center", width:"29%"}}>
                                                            <div style={{marginRight:"3px"}}>
                                                            <span style={{paddingRight:"8px"}}>
                                                                <b>Филиал:</b> {getAffiliateDataOrder(subscriber)}
                                                            </span><br/>
                                                                <span style={{paddingRight:"8px"}}>
                                                                <b>Торговая точка:</b> {getOutletsDataOrder(subscriber)}
                                                            </span>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-content-end align-content-between" style={{alignItems:"center",width:"80%"}}>
                                                            {/*{getKlietnInfo(subscriber.klient)}*/}
                                                            <div style={{width:"80px",wordBreak:"normal"}}><b>Отметки:</b></div>{getMarksOrder(subscriber.marks)}
                                                        </div>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </>}
                                </TableBody>
                                    <TableBody key={"Orders_Date_TB_NONE"+index}>
                                        <TableRow key={index+"_info"} id={"separator_"+index} style={{border:"none"}}>
                                            <TableCell colSpan={10} height="6px" style={{border:"none"}}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            )}
                        )}
                </Table> }

            <TablePagination
                className="px-4"
                rowsPerPageOptions={[3, 5, 10, 25]}
                component="div"
                count={subscribarList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                backIconButtonProps={{
                    'aria-label': 'Предыдущая страница',
                }}
                nextIconButtonProps={{
                    'aria-label': 'Следующая страница',
                }}
                labelRowsPerPage="Вывод на страницу по"
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    )
}
const tmpOrder= {"OrderList":
        {
            "1654732800": {
                "28": {
                    "id": "28",
                    "id_user": "2",
                    "id_klient": "3",
                    "id_affiliate": "2",
                    "id_points": "0",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654787483",
                    "date_delivered": "1654865798",
                    "dateCreateText": "2022-06-09 15:11:23",
                    "products": [
                        {
                            "id": 127,
                            "id_order": "28",
                            "id_product": 18,
                            "id_category": 1,
                            "title": "Сет Хот",
                            "price": "790",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "волк, восстание, хоккайдо, 24 шт., 1000 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Сет Хот"
                        },
                        {
                            "id": 128,
                            "id_order": "28",
                            "id_product": 20,
                            "id_category": 1,
                            "title": "Наслаждение",
                            "price": "999",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Люкс, Нежность, Филадельфия под угрем, 24шт., 850гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Наслаждение"
                        },
                        {
                            "id": 129,
                            "id_order": "28",
                            "id_product": 21,
                            "id_category": 1,
                            "title": "Хайп",
                            "price": "1800",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия (2шт), Филадельфия max, Летний, Лосось, суши лосось, Волк, Феникс, Фудзияма, Хот Лосось, 71шт., 2175гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Хайп"
                        }
                    ],
                    "orderData": {
                        "id": "23",
                        "id_order": "28",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654787483",
                        "id_klient": "3",
                        "comment": "Заказ отправленный из панели управления страница - новый заказ фастфуд",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "2",
                        "ItogSumOrder": "3589",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "3589",
                    "klient": {
                        "id": "3",
                        "id_user": "2",
                        "id_organization": "2",
                        "firstName": "Кирилл",
                        "lastName": "Крутиков",
                        "phone": "79805684444",
                        "email": "mail@mail.com",
                        "birthday": "2022-05-11T11:09:00.000Z",
                        "birthdayText": "2022-5-11",
                        "comment": "sadasd",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "12",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "24",
                        "id_user": "2",
                        "id_order": "28",
                        "id_affiliate": "2",
                        "pointOrderId": "9",
                        "timeDeliveredType": "1",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-9",
                        "dateDelivered": "2022-06-10T16:53:00.000Z",
                        "timeDeliveredText": "22:00",
                        "timeDelivered": "2022-06-09T19:00:03.255Z",
                        "dateSetOrder": "2022-06-09T15:11:23.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "82",
                            "id_order": "28",
                            "id_marks": "18",
                            "name": "Ожидание 3-3,5 часа",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "83",
                            "id_order": "28",
                            "id_marks": "8",
                            "name": "ГОСТИ",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "84",
                            "id_order": "28",
                            "id_marks": "9",
                            "name": "ДОМОФОН НЕ РАБОТАЕТ",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "85",
                            "id_order": "28",
                            "id_marks": "11",
                            "name": "ОБЯЗАТЕЛЬНО ПОЗВОНИТЬ",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "43",
                        "id_order": "28",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "4",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654902259"
                    },
                    "statusOrderAll": [
                        {
                            "id": "16",
                            "id_order": "28",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        },
                        {
                            "id": "21",
                            "id_order": "28",
                            "id_worker": "1",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        },
                        {
                            "id": "23",
                            "id_order": "28",
                            "id_worker": "2",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654871537"
                        },
                        {
                            "id": "29",
                            "id_order": "28",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "5",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654872166"
                        },
                        {
                            "id": "32",
                            "id_order": "28",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875486"
                        },
                        {
                            "id": "33",
                            "id_order": "28",
                            "id_worker": "1",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875488"
                        },
                        {
                            "id": "43",
                            "id_order": "28",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654902259"
                        }
                    ]
                },
                "29": {
                    "id": "29",
                    "id_user": "2",
                    "id_klient": "3",
                    "id_affiliate": "2",
                    "id_points": "0",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654787815",
                    "date_delivered": "1654787815",
                    "dateCreateText": "2022-06-09 15:16:55",
                    "products": [
                        {
                            "id": 130,
                            "id_order": "29",
                            "id_product": 1,
                            "id_category": 1,
                            "title": "Мини ХОТ",
                            "price": "350",
                            "active": true,
                            "art": "1435",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Ролл Лосось Спайси, Ролл Окунь Спаси, Ролл Курица Шеф, 18шт., 400гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Мини ХОТ"
                        },
                        {
                            "id": 131,
                            "id_order": "29",
                            "id_product": 2,
                            "id_category": 2,
                            "title": "Немо",
                            "price": "245",
                            "active": true,
                            "art": "6453",
                            "units": "1",
                            "discount": false,
                            "color": "1",
                            "description": "Рис, нори, сливочный сыр, огурец, тамаго, окунь, лосось, 280 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Немо"
                        },
                        {
                            "id": 132,
                            "id_order": "29",
                            "id_product": 13,
                            "id_category": 3,
                            "title": "Суши Икура",
                            "price": "120",
                            "active": true,
                            "art": "432",
                            "units": "1",
                            "discount": true,
                            "color": "4",
                            "description": "423erfds",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Суши Икура"
                        },
                        {
                            "id": 133,
                            "id_order": "29",
                            "id_product": 8,
                            "id_category": 4,
                            "title": "Маргарита (Томатная основа)",
                            "price": "340",
                            "active": true,
                            "art": "",
                            "units": "7",
                            "discount": true,
                            "color": "3",
                            "description": "товары пицца",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Маргарита (Томатная основа)"
                        },
                        {
                            "id": 134,
                            "id_order": "29",
                            "id_product": 14,
                            "id_category": 12,
                            "title": "1s",
                            "price": "1",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "1s"
                        },
                        {
                            "id": 135,
                            "id_order": "29",
                            "id_product": 9,
                            "id_category": 5,
                            "title": "Паста Карбонара",
                            "price": "270",
                            "active": true,
                            "art": "",
                            "units": "6",
                            "discount": true,
                            "color": "12",
                            "description": "Лапша Рамен, Сливки, Бекон, Вино, Лук зеленый, Приправа Оригано, Шампиньоны, Яйцо, Сыр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Паста Карбонара"
                        },
                        {
                            "id": 136,
                            "id_order": "29",
                            "id_product": 11,
                            "id_category": 6,
                            "title": "апрвар",
                            "price": "465",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "13",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "апрвар"
                        },
                        {
                            "id": 137,
                            "id_order": "29",
                            "id_product": 12,
                            "id_category": 7,
                            "title": "Салат с Тигровой Креветкой",
                            "price": "230",
                            "active": true,
                            "art": "",
                            "units": "4",
                            "discount": true,
                            "color": "1",
                            "description": "Салат листовой, креветка тигровая обжаренная, огурец, помидор, перец, соус горчичный, кунжут, 240гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Салат с Тигровой Креветкой"
                        },
                        {
                            "id": 138,
                            "id_order": "29",
                            "id_product": 34,
                            "id_category": 8,
                            "title": "Мидии под сырным соусом (Бусидо)",
                            "price": "360",
                            "active": true,
                            "art": "",
                            "units": "6",
                            "discount": true,
                            "color": "1",
                            "description": "Мидии Киви, Сырный соус (Майонез, Чеснок, Сыр, Масаго), 240 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Мидии под сырным соусом (Бусидо)"
                        },
                        {
                            "id": 139,
                            "id_order": "29",
                            "id_product": 35,
                            "id_category": 10,
                            "title": "Тестовый товар к закускам с картинкой",
                            "price": "434",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "7",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Тестовый товар к закускам с картинкой"
                        }
                    ],
                    "orderData": {
                        "id": "24",
                        "id_order": "29",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654787815",
                        "id_klient": "3",
                        "comment": "sads",
                        "discountSale": "2",
                        "promokodeId": "4",
                        "sdacha": "10",
                        "typePayment": "1",
                        "ItogSumOrder": "2111",
                        "ItogSumOrderNoDiscount": "2815",
                        "sumDiscountOrder": "703"
                    },
                    "ItogSumOrder": "2111",
                    "klient": {
                        "id": "3",
                        "id_user": "2",
                        "id_organization": "2",
                        "firstName": "Кирилл",
                        "lastName": "Крутиков",
                        "phone": "79805684444",
                        "email": "mail@mail.com",
                        "birthday": "2022-05-11T11:09:00.000Z",
                        "birthdayText": "2022-5-11",
                        "comment": "sadasd",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "12",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "25",
                        "id_user": "2",
                        "id_order": "29",
                        "id_affiliate": "2",
                        "pointOrderId": "9",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": false,
                        "dateDeliveredText": "2022-6-9",
                        "dateDelivered": "2022-06-09T17:14:20.519Z",
                        "timeDeliveredText": "18:14",
                        "timeDelivered": "2022-06-09T17:14:20.519Z",
                        "dateSetOrder": "2022-06-09T15:16:55.000Z",
                        "active": false,
                        "adres": {
                            "id": "13",
                            "id_address": "9",
                            "id_user": "2",
                            "id_order": "29",
                            "city": "Дубовое",
                            "street": "lkhjaeff",
                            "home": "1",
                            "entrance": "4",
                            "floor": "5",
                            "apartament": "44",
                            "comment": "ddaawers",
                            "active": true,
                            "deleted": "0",
                            "id_delivered": "25"
                        }
                    },
                    "marks": [
                        {
                            "id": "86",
                            "id_order": "29",
                            "id_marks": "24",
                            "name": "ЧИБИС",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "87",
                            "id_order": "29",
                            "id_marks": "3",
                            "name": "БЕЗ СДАЧИ",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "88",
                            "id_order": "29",
                            "id_marks": "1",
                            "name": "ДОСТАВКА",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "2815",
                    "sumDiscountOrder": "703",
                    "statusOrder": {
                        "id": "34",
                        "id_order": "29",
                        "id_worker": "3",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654875667"
                    },
                    "statusOrderAll": [
                        {
                            "id": "17",
                            "id_order": "29",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        },
                        {
                            "id": "34",
                            "id_order": "29",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875667"
                        }
                    ]
                },
                "30": {
                    "id": "30",
                    "id_user": "2",
                    "id_klient": "4",
                    "id_affiliate": "2",
                    "id_points": "0",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654788211",
                    "date_delivered": "1654788211",
                    "dateCreateText": "2022-06-09 15:23:31",
                    "products": [
                        {
                            "id": 140,
                            "id_order": "30",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        },
                        {
                            "id": 141,
                            "id_order": "30",
                            "id_product": 18,
                            "id_category": 1,
                            "title": "Сет Хот",
                            "price": "790",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "волк, восстание, хоккайдо, 24 шт., 1000 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Сет Хот"
                        },
                        {
                            "id": 142,
                            "id_order": "30",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 143,
                            "id_order": "30",
                            "id_product": 21,
                            "id_category": 1,
                            "title": "Хайп",
                            "price": "1800",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия (2шт), Филадельфия max, Летний, Лосось, суши лосось, Волк, Феникс, Фудзияма, Хот Лосось, 71шт., 2175гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Хайп"
                        },
                        {
                            "id": 144,
                            "id_order": "30",
                            "id_product": 20,
                            "id_category": 1,
                            "title": "Наслаждение",
                            "price": "999",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Люкс, Нежность, Филадельфия под угрем, 24шт., 850гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Наслаждение"
                        }
                    ],
                    "orderData": {
                        "id": "25",
                        "id_order": "30",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654788211",
                        "id_klient": "4",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "5213",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "5213",
                    "klient": {
                        "id": "4",
                        "id_user": "2",
                        "id_organization": "0",
                        "firstName": "тест",
                        "lastName": null,
                        "phone": "792058576463",
                        "email": "test@email.com",
                        "birthday": "2022-06-09T15:22:38.632Z",
                        "birthdayText": "2022-6-9",
                        "comment": "Тестовый клиент, которого тут нет в базе",
                        "chanel": "4",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "26",
                        "id_user": "2",
                        "id_order": "30",
                        "id_affiliate": "2",
                        "pointOrderId": "5",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-9",
                        "dateDelivered": "2022-06-09T17:22:23.437Z",
                        "timeDeliveredText": "18:22",
                        "timeDelivered": "2022-06-09T17:22:23.437Z",
                        "dateSetOrder": "2022-06-09T15:23:31.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": null,
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "35",
                        "id_order": "30",
                        "id_worker": "1",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654875670"
                    },
                    "statusOrderAll": [
                        {
                            "id": "18",
                            "id_order": "30",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        },
                        {
                            "id": "35",
                            "id_order": "30",
                            "id_worker": "1",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875670"
                        }
                    ]
                },
                "31": {
                    "id": "31",
                    "id_user": "2",
                    "id_klient": "4",
                    "id_affiliate": "1",
                    "id_points": "4",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654796014",
                    "date_delivered": "1654796014",
                    "dateCreateText": "2022-06-09 17:33:34",
                    "products": [
                        {
                            "id": 145,
                            "id_order": "31",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 146,
                            "id_order": "31",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        },
                        {
                            "id": 147,
                            "id_order": "31",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        }
                    ],
                    "orderData": {
                        "id": "26",
                        "id_order": "31",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654796014",
                        "id_klient": "4",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "2323",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "2323",
                    "klient": {
                        "id": "4",
                        "id_user": "2",
                        "id_organization": "0",
                        "firstName": "тест",
                        "lastName": null,
                        "phone": "792058576463",
                        "email": "test@email.com",
                        "birthday": "2022-06-09T15:22:38.632Z",
                        "birthdayText": "2022-6-9",
                        "comment": "Тестовый клиент, которого тут нет в базе",
                        "chanel": "4",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "27",
                        "id_user": "2",
                        "id_order": "31",
                        "id_affiliate": "3",
                        "pointOrderId": "4",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-9",
                        "dateDelivered": "2022-06-09T19:33:06.135Z",
                        "timeDeliveredText": "20:33",
                        "timeDelivered": "2022-06-09T19:33:06.135Z",
                        "dateSetOrder": "2022-06-09T17:33:34.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "89",
                            "id_order": "31",
                            "id_marks": "22",
                            "name": "Ожидание 50 мин",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "90",
                            "id_order": "31",
                            "id_marks": "13",
                            "name": "Ожидание 1 час",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "36",
                        "id_order": "31",
                        "id_worker": "1",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654875673"
                    },
                    "statusOrderAll": [
                        {
                            "id": "19",
                            "id_order": "31",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        },
                        {
                            "id": "36",
                            "id_order": "31",
                            "id_worker": "1",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875673"
                        }
                    ]
                },
                "33": {
                    "id": "33",
                    "id_user": "2",
                    "id_klient": "1",
                    "id_affiliate": "1",
                    "id_points": "2",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654796305",
                    "date_delivered": "1654796305",
                    "dateCreateText": "2022-06-09 17:38:25",
                    "products": [
                        {
                            "id": 164,
                            "id_order": "33",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        },
                        {
                            "id": 165,
                            "id_order": "33",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 2,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 166,
                            "id_order": "33",
                            "id_product": 18,
                            "id_category": 1,
                            "title": "Сет Хот",
                            "price": "790",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "волк, восстание, хоккайдо, 24 шт., 1000 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Сет Хот"
                        },
                        {
                            "id": 167,
                            "id_order": "33",
                            "id_product": 20,
                            "id_category": 1,
                            "title": "Наслаждение",
                            "price": "999",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Люкс, Нежность, Филадельфия под угрем, 24шт., 850гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Наслаждение"
                        },
                        {
                            "id": 168,
                            "id_order": "33",
                            "id_product": 21,
                            "id_category": 1,
                            "title": "Хайп",
                            "price": "1800",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия (2шт), Филадельфия max, Летний, Лосось, суши лосось, Волк, Феникс, Фудзияма, Хот Лосось, 71шт., 2175гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Хайп"
                        },
                        {
                            "id": 169,
                            "id_order": "33",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        },
                        {
                            "id": 170,
                            "id_order": "33",
                            "id_product": 1,
                            "id_category": 1,
                            "title": "Мини ХОТ",
                            "price": "350",
                            "active": true,
                            "art": "1435",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Ролл Лосось Спайси, Ролл Окунь Спаси, Ролл Курица Шеф, 18шт., 400гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Мини ХОТ"
                        },
                        {
                            "id": 171,
                            "id_order": "33",
                            "id_product": 13,
                            "id_category": 3,
                            "title": "Суши Икура",
                            "price": "120",
                            "active": true,
                            "art": "432",
                            "units": "1",
                            "discount": true,
                            "color": "4",
                            "description": "423erfds",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Суши Икура"
                        },
                        {
                            "id": 172,
                            "id_order": "33",
                            "id_product": 24,
                            "id_category": 3,
                            "title": "Суши Лосось",
                            "price": "60",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Суши Лосось"
                        },
                        {
                            "id": 173,
                            "id_order": "33",
                            "id_product": 25,
                            "id_category": 3,
                            "title": "Суши Угорь",
                            "price": "90",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Суши Угорь"
                        },
                        {
                            "id": 174,
                            "id_order": "33",
                            "id_product": 23,
                            "id_category": 3,
                            "title": "Суши Тигровая Креветка",
                            "price": "75",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Суши Тигровая Креветка"
                        },
                        {
                            "id": 175,
                            "id_order": "33",
                            "id_product": 14,
                            "id_category": 12,
                            "title": "1s",
                            "price": "1",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "1s"
                        },
                        {
                            "id": 176,
                            "id_order": "33",
                            "id_product": 29,
                            "id_category": 5,
                            "title": "Рамен сливочный с курицей",
                            "price": "235",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "Яичная лапша, Курица, Лук репчатый, фасоль стручковая, Кабачок, Брокколи, грибы Шампиньоны, Сливки, Соевый соус, Зеленый лук, Кунжут 390 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Рамен сливочный с курицей"
                        },
                        {
                            "id": 177,
                            "id_order": "33",
                            "id_product": 9,
                            "id_category": 5,
                            "title": "Паста Карбонара",
                            "price": "270",
                            "active": true,
                            "art": "",
                            "units": "6",
                            "discount": true,
                            "color": "12",
                            "description": "Лапша Рамен, Сливки, Бекон, Вино, Лук зеленый, Приправа Оригано, Шампиньоны, Яйцо, Сыр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Паста Карбонара"
                        },
                        {
                            "id": 178,
                            "id_order": "33",
                            "id_product": 10,
                            "id_category": 5,
                            "title": "Удон с курицей и беконом",
                            "price": "260",
                            "active": true,
                            "art": "",
                            "units": "6",
                            "discount": true,
                            "color": "12",
                            "description": "Пшеничная лапша обжаренная с курицей, бекон, фасоль, лук, морковь, кабачок, брокколи, грибы шампиньоны, соус карри, кокосовое молоко, кунжут (400гр).",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Удон с курицей и беконом"
                        },
                        {
                            "id": 179,
                            "id_order": "33",
                            "id_product": 30,
                            "id_category": 5,
                            "title": "Удон сливочный с креветкой и лососем",
                            "price": "320",
                            "active": true,
                            "art": "",
                            "units": "",
                            "discount": true,
                            "color": "1",
                            "description": "Пшеничная лапша, Тигровая креветка, Лосось, Овощная смесь (Лук репчатый, Кабачок, Брокколи, грибы Шампиньоны), Соевый соус, Сливочный соус, Кунжут, Зеленый лук, 370 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Удон сливочный с креветкой и лососем"
                        }
                    ],
                    "orderData": {
                        "id": "28",
                        "id_order": "33",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654796305",
                        "id_klient": "1",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "8618",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "8618",
                    "klient": {
                        "id": "1",
                        "id_user": "2",
                        "id_organization": "3",
                        "firstName": "Евгений",
                        "lastName": null,
                        "phone": "79205952527",
                        "email": "uk091@yandex.ru",
                        "birthday": "1993-09-08T20:00:00.000Z",
                        "birthdayText": "1993-9-9",
                        "comment": "Примечание к самому клиенту, указанное в карточке",
                        "chanel": "2",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "28",
                        "id_user": "2",
                        "id_order": "33",
                        "id_affiliate": "1",
                        "pointOrderId": "2",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-9",
                        "dateDelivered": "2022-06-09T19:33:06.135Z",
                        "timeDeliveredText": "20:33",
                        "timeDelivered": "2022-06-09T19:33:06.135Z",
                        "dateSetOrder": "2022-06-09T17:38:25.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "94",
                            "id_order": "33",
                            "id_marks": "19",
                            "name": "Ожидание 3 часа",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "95",
                            "id_order": "33",
                            "id_marks": "17",
                            "name": "Ожидание 3 часа",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "96",
                            "id_order": "33",
                            "id_marks": "5",
                            "name": "ПИТАНИЕ П",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "20",
                        "id_order": "33",
                        "id_worker": "0",
                        "id_account": "0",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "0"
                    },
                    "statusOrderAll": [
                        {
                            "id": "20",
                            "id_order": "33",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "0"
                        }
                    ]
                }
            },
            "1654819200": {
                "34": {
                    "id": "34",
                    "id_user": "2",
                    "id_klient": "4",
                    "id_affiliate": "3",
                    "id_points": "9",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654865798",
                    "date_delivered": "1654865798",
                    "dateCreateText": "2022-06-10 12:56:38",
                    "products": [
                        {
                            "id": 180,
                            "id_order": "34",
                            "id_product": 1,
                            "id_category": 1,
                            "title": "Мини ХОТ",
                            "price": "350",
                            "active": true,
                            "art": "1435",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Ролл Лосось Спайси, Ролл Окунь Спаси, Ролл Курица Шеф, 18шт., 400гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Мини ХОТ"
                        }
                    ],
                    "orderData": {
                        "id": "29",
                        "id_order": "34",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654865798",
                        "id_klient": "4",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "350",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "350",
                    "klient": {
                        "id": "4",
                        "id_user": "2",
                        "id_organization": "0",
                        "firstName": "тест",
                        "lastName": null,
                        "phone": "792058576463",
                        "email": "test@email.com",
                        "birthday": "2022-06-09T15:22:38.632Z",
                        "birthdayText": "2022-6-9",
                        "comment": "Тестовый клиент, которого тут нет в базе",
                        "chanel": "4",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "29",
                        "id_user": "2",
                        "id_order": "34",
                        "id_affiliate": "3",
                        "pointOrderId": "9",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-10",
                        "dateDelivered": "2022-06-10T14:56:22.058Z",
                        "timeDeliveredText": "15:56",
                        "timeDelivered": "2022-06-10T14:56:22.058Z",
                        "dateSetOrder": "2022-06-10T12:56:38.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": null,
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "46",
                        "id_order": "34",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "6",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654903418"
                    },
                    "statusOrderAll": [
                        {
                            "id": "22",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "0",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654865798"
                        },
                        {
                            "id": "24",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654871556"
                        },
                        {
                            "id": "25",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654871602"
                        },
                        {
                            "id": "26",
                            "id_order": "34",
                            "id_worker": "2",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "5",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654871626"
                        },
                        {
                            "id": "27",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "9",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654871739"
                        },
                        {
                            "id": "28",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654872162"
                        },
                        {
                            "id": "30",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654872988"
                        },
                        {
                            "id": "31",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654873090"
                        },
                        {
                            "id": "37",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654875733"
                        },
                        {
                            "id": "38",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654893031"
                        },
                        {
                            "id": "39",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654893032"
                        },
                        {
                            "id": "40",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654893053"
                        },
                        {
                            "id": "41",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654900685"
                        },
                        {
                            "id": "42",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654902256"
                        },
                        {
                            "id": "44",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654902269"
                        },
                        {
                            "id": "45",
                            "id_order": "34",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654903256"
                        },
                        {
                            "id": "46",
                            "id_order": "34",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654903418"
                        }
                    ]
                }
            },
            "1654905600": {
                "35": {
                    "id": "35",
                    "id_user": "2",
                    "id_klient": "1",
                    "id_affiliate": "1",
                    "id_points": "2",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1654936795",
                    "date_delivered": "1654936795",
                    "dateCreateText": "2022-06-11 08:39:55",
                    "products": [
                        {
                            "id": 181,
                            "id_order": "35",
                            "id_product": 3,
                            "id_category": 1,
                            "title": "Вкус Любви",
                            "price": "690",
                            "active": true,
                            "art": "1435",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Вкус Любви"
                        },
                        {
                            "id": 182,
                            "id_order": "35",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        },
                        {
                            "id": 183,
                            "id_order": "35",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        }
                    ],
                    "orderData": {
                        "id": "30",
                        "id_order": "35",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1654936795",
                        "id_klient": "1",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "2088",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "2088",
                    "klient": {
                        "id": "1",
                        "id_user": "2",
                        "id_organization": "3",
                        "firstName": "Евгений",
                        "lastName": null,
                        "phone": "79205952527",
                        "email": "uk091@yandex.ru",
                        "birthday": "1993-09-08T20:00:00.000Z",
                        "birthdayText": "1993-9-9",
                        "comment": "Примечание к самому клиенту, указанное в карточке",
                        "chanel": "2",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "30",
                        "id_user": "2",
                        "id_order": "35",
                        "id_affiliate": "1",
                        "pointOrderId": "2",
                        "timeDeliveredType": "1",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-11",
                        "dateDelivered": "2022-06-11T10:39:34.688Z",
                        "timeDeliveredText": "09:08",
                        "timeDelivered": "2022-06-11T06:08:34.688Z",
                        "dateSetOrder": "2022-06-11T08:39:55.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": null,
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "47",
                        "id_order": "35",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1654936795"
                    },
                    "statusOrderAll": [
                        {
                            "id": "47",
                            "id_order": "35",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1654936795"
                        }
                    ]
                }
            },
            "1654992000": {
                "36": {
                    "id": "36",
                    "id_user": "2",
                    "id_klient": "3",
                    "id_affiliate": "1",
                    "id_points": "4",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655048379",
                    "date_delivered": "1655048379",
                    "dateCreateText": "2022-06-12 15:39:39",
                    "products": [
                        {
                            "id": 184,
                            "id_order": "36",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 185,
                            "id_order": "36",
                            "id_product": 3,
                            "id_category": 1,
                            "title": "Вкус Любви",
                            "price": "690",
                            "active": true,
                            "art": "1435",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Вкус Любви"
                        }
                    ],
                    "orderData": {
                        "id": "31",
                        "id_order": "36",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655048379",
                        "id_klient": "3",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "1615",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "1615",
                    "klient": {
                        "id": "3",
                        "id_user": "2",
                        "id_organization": "2",
                        "firstName": "Кирилл",
                        "lastName": "Крутиков",
                        "phone": "79805684444",
                        "email": "mail@mail.com",
                        "birthday": "2022-05-11T11:09:00.000Z",
                        "birthdayText": "2022-5-11",
                        "comment": "sadasd",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "12",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "31",
                        "id_user": "2",
                        "id_order": "36",
                        "id_affiliate": "1",
                        "pointOrderId": "4",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": false,
                        "dateDeliveredText": "2022-6-12",
                        "dateDelivered": "2022-06-12T17:38:58.186Z",
                        "timeDeliveredText": "18:38",
                        "timeDelivered": "2022-06-12T17:38:58.186Z",
                        "dateSetOrder": "2022-06-12T15:39:39.000Z",
                        "active": false,
                        "adres": {
                            "id": "14",
                            "id_address": "10",
                            "id_user": "2",
                            "id_order": "36",
                            "city": "Новосадовый",
                            "street": "Садовая",
                            "home": "59",
                            "entrance": "2",
                            "floor": "3",
                            "apartament": "13",
                            "comment": null,
                            "active": true,
                            "deleted": "0",
                            "id_delivered": "31"
                        }
                    },
                    "marks": [
                        {
                            "id": "97",
                            "id_order": "36",
                            "id_marks": "21",
                            "name": "Ожидание 40 мин",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "98",
                            "id_order": "36",
                            "id_marks": "11",
                            "name": "ОБЯЗАТЕЛЬНО ПОЗВОНИТЬ",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "48",
                        "id_order": "36",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655048379"
                    },
                    "statusOrderAll": [
                        {
                            "id": "48",
                            "id_order": "36",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655048379"
                        }
                    ]
                }
            },
            "1655164800": {
                "37": {
                    "id": "37",
                    "id_user": "2",
                    "id_klient": "2",
                    "id_affiliate": "1",
                    "id_points": "3",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655168239",
                    "date_delivered": "1655168239",
                    "dateCreateText": "2022-06-14 00:57:19",
                    "products": [
                        {
                            "id": 186,
                            "id_order": "37",
                            "id_product": 3,
                            "id_category": 1,
                            "title": "Вкус Любви",
                            "price": "690",
                            "active": true,
                            "art": "1435",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Вкус Любви"
                        },
                        {
                            "id": 187,
                            "id_order": "37",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        }
                    ],
                    "orderData": {
                        "id": "32",
                        "id_order": "37",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655168239",
                        "id_klient": "2",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "1389",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "1389",
                    "klient": {
                        "id": "2",
                        "id_user": "2",
                        "id_organization": "1",
                        "firstName": "Демьян",
                        "lastName": null,
                        "phone": "79511530614",
                        "email": "ildim@mail.ru",
                        "birthday": "1994-02-01T21:00:00.000Z",
                        "birthdayText": "1994-2-2",
                        "comment": "Примечание к клиенту, в заказе",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "32",
                        "id_user": "2",
                        "id_order": "37",
                        "id_affiliate": "1",
                        "pointOrderId": "3",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-14",
                        "dateDelivered": "2022-06-14T02:56:59.949Z",
                        "timeDeliveredText": "03:56",
                        "timeDelivered": "2022-06-14T02:56:59.949Z",
                        "dateSetOrder": "2022-06-14T00:57:19.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "99",
                            "id_order": "37",
                            "id_marks": "21",
                            "name": "Ожидание 40 мин",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "57",
                        "id_order": "37",
                        "id_worker": "1",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "6",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655298930"
                    },
                    "statusOrderAll": [
                        {
                            "id": "49",
                            "id_order": "37",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655168239"
                        },
                        {
                            "id": "54",
                            "id_order": "37",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655243581"
                        },
                        {
                            "id": "55",
                            "id_order": "37",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "8",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655298926"
                        },
                        {
                            "id": "56",
                            "id_order": "37",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655298928"
                        },
                        {
                            "id": "57",
                            "id_order": "37",
                            "id_worker": "1",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "6",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655298930"
                        }
                    ]
                },
                "38": {
                    "id": "38",
                    "id_user": "2",
                    "id_klient": "3",
                    "id_affiliate": "3",
                    "id_points": "9",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655224739",
                    "date_delivered": "1655224739",
                    "dateCreateText": "2022-06-14 16:38:59",
                    "products": [
                        {
                            "id": 188,
                            "id_order": "38",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 189,
                            "id_order": "38",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        },
                        {
                            "id": 190,
                            "id_order": "38",
                            "id_product": 3,
                            "id_category": 1,
                            "title": "Вкус Любви",
                            "price": "690",
                            "active": true,
                            "art": "1435",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Вкус Любви"
                        }
                    ],
                    "orderData": {
                        "id": "33",
                        "id_order": "38",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655224739",
                        "id_klient": "3",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "2314",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "2314",
                    "klient": {
                        "id": "3",
                        "id_user": "2",
                        "id_organization": "2",
                        "firstName": "Кирилл",
                        "lastName": "Крутиков",
                        "phone": "79805684444",
                        "email": "mail@mail.com",
                        "birthday": "2022-05-11T11:09:00.000Z",
                        "birthdayText": "2022-5-11",
                        "comment": "sadasd",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "12",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "33",
                        "id_user": "2",
                        "id_order": "38",
                        "id_affiliate": "3",
                        "pointOrderId": "9",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-14",
                        "dateDelivered": "2022-06-14T18:36:09.046Z",
                        "timeDeliveredText": "19:36",
                        "timeDelivered": "2022-06-14T18:36:09.046Z",
                        "dateSetOrder": "2022-06-14T16:38:59.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "100",
                            "id_order": "38",
                            "id_marks": "22",
                            "name": "Ожидание 50 мин",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "53",
                        "id_order": "38",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "4",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655243578"
                    },
                    "statusOrderAll": [
                        {
                            "id": "50",
                            "id_order": "38",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655224739"
                        },
                        {
                            "id": "53",
                            "id_order": "38",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "4",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655243578"
                        }
                    ]
                },
                "39": {
                    "id": "39",
                    "id_user": "2",
                    "id_klient": "2",
                    "id_affiliate": "1",
                    "id_points": "4",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655224769",
                    "date_delivered": "1655246340",
                    "dateCreateText": "2022-06-14 16:39:29",
                    "products": [
                        {
                            "id": 191,
                            "id_order": "39",
                            "id_product": 20,
                            "id_category": 1,
                            "title": "Наслаждение",
                            "price": "999",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Люкс, Нежность, Филадельфия под угрем, 24шт., 850гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Наслаждение"
                        },
                        {
                            "id": 192,
                            "id_order": "39",
                            "id_product": 21,
                            "id_category": 1,
                            "title": "Хайп",
                            "price": "1800",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия (2шт), Филадельфия max, Летний, Лосось, суши лосось, Волк, Феникс, Фудзияма, Хот Лосось, 71шт., 2175гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Хайп"
                        },
                        {
                            "id": 193,
                            "id_order": "39",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 194,
                            "id_order": "39",
                            "id_product": 18,
                            "id_category": 1,
                            "title": "Сет Хот",
                            "price": "790",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "волк, восстание, хоккайдо, 24 шт., 1000 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Сет Хот"
                        },
                        {
                            "id": 195,
                            "id_order": "39",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        }
                    ],
                    "orderData": {
                        "id": "34",
                        "id_order": "39",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655224769",
                        "id_klient": "2",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "5213",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "5213",
                    "klient": {
                        "id": "2",
                        "id_user": "2",
                        "id_organization": "1",
                        "firstName": "Демьян",
                        "lastName": null,
                        "phone": "79511530614",
                        "email": "ildim@mail.ru",
                        "birthday": "1994-02-01T21:00:00.000Z",
                        "birthdayText": "1994-2-2",
                        "comment": "Примечание к клиенту, в заказе",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "34",
                        "id_user": "2",
                        "id_order": "39",
                        "id_affiliate": "1",
                        "pointOrderId": "4",
                        "timeDeliveredType": "1",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-14",
                        "dateDelivered": "2022-06-14T18:39:11.728Z",
                        "timeDeliveredText": "22:39",
                        "timeDelivered": "2022-06-14T19:39:11.728Z",
                        "dateSetOrder": "2022-06-14T16:39:29.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": null,
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "52",
                        "id_order": "39",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "9",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655243576"
                    },
                    "statusOrderAll": [
                        {
                            "id": "51",
                            "id_order": "39",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655224769"
                        },
                        {
                            "id": "52",
                            "id_order": "39",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "9",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655243576"
                        }
                    ]
                }
            },
            "1655683200": {
                "40": {
                    "id": "40",
                    "id_user": "2",
                    "id_klient": "3",
                    "id_affiliate": "3",
                    "id_points": "9",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655718320",
                    "date_delivered": "1655718320",
                    "dateCreateText": "2022-06-20 09:45:20",
                    "products": [
                        {
                            "id": 196,
                            "id_order": "40",
                            "id_product": 3,
                            "id_category": 1,
                            "title": "Вкус Любви",
                            "price": "690",
                            "active": true,
                            "art": "1435",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Вкус Любви"
                        },
                        {
                            "id": 197,
                            "id_order": "40",
                            "id_product": 16,
                            "id_category": 1,
                            "title": "Жара",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Жара"
                        },
                        {
                            "id": 198,
                            "id_order": "40",
                            "id_product": 17,
                            "id_category": 1,
                            "title": "Филадельфия Микс",
                            "price": "699",
                            "active": true,
                            "art": "",
                            "units": "1",
                            "discount": true,
                            "color": "1",
                            "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Филадельфия Микс"
                        }
                    ],
                    "orderData": {
                        "id": "35",
                        "id_order": "40",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655718320",
                        "id_klient": "3",
                        "comment": "",
                        "discountSale": "0",
                        "promokodeId": "0",
                        "sdacha": "0",
                        "typePayment": "0",
                        "ItogSumOrder": "2088",
                        "ItogSumOrderNoDiscount": "0",
                        "sumDiscountOrder": "0"
                    },
                    "ItogSumOrder": "2088",
                    "klient": {
                        "id": "3",
                        "id_user": "2",
                        "id_organization": "2",
                        "firstName": "Кирилл",
                        "lastName": "Крутиков",
                        "phone": "79805684444",
                        "email": "mail@mail.com",
                        "birthday": "2022-05-11T11:09:00.000Z",
                        "birthdayText": "2022-5-11",
                        "comment": "sadasd",
                        "chanel": "0",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "12",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "35",
                        "id_user": "2",
                        "id_order": "40",
                        "id_affiliate": "3",
                        "pointOrderId": "9",
                        "timeDeliveredType": "0",
                        "typeDeliveredOrder": true,
                        "dateDeliveredText": "2022-6-20",
                        "dateDelivered": "2022-06-20T11:44:58.411Z",
                        "timeDeliveredText": "12:44",
                        "timeDelivered": "2022-06-20T11:44:58.411Z",
                        "dateSetOrder": "2022-06-20T09:45:20.000Z",
                        "active": false,
                        "adres": false
                    },
                    "marks": [
                        {
                            "id": "101",
                            "id_order": "40",
                            "id_marks": "23",
                            "name": "РЕКЛАМА",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "102",
                            "id_order": "40",
                            "id_marks": "17",
                            "name": "Ожидание 3 часа",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "103",
                            "id_order": "40",
                            "id_marks": "4",
                            "name": "БЕЗНАЛИЧНЫЙ РАСЧЕТ",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "0",
                    "sumDiscountOrder": "0",
                    "statusOrder": {
                        "id": "60",
                        "id_order": "40",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "5",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655718370"
                    },
                    "statusOrderAll": [
                        {
                            "id": "58",
                            "id_order": "40",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655718320"
                        },
                        {
                            "id": "59",
                            "id_order": "40",
                            "id_worker": "3",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655718368"
                        },
                        {
                            "id": "60",
                            "id_order": "40",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "5",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655718370"
                        }
                    ]
                },
                "41": {
                    "id": "41",
                    "id_user": "2",
                    "id_klient": "4",
                    "id_affiliate": "1",
                    "id_points": "4",
                    "type": "1",
                    "deleted": "0",
                    "date_create": "1655745899",
                    "date_delivered": "1655745900",
                    "dateCreateText": "2022-06-20 17:24:59",
                    "products": [
                        {
                            "id": 199,
                            "id_order": "41",
                            "id_product": 19,
                            "id_category": 1,
                            "title": "Каникулы",
                            "price": "925",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "Вакай, Шанхай, Фудзияма, Крабик, Филадельфия, 40шт., 1,5 кг.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Каникулы"
                        },
                        {
                            "id": 200,
                            "id_order": "41",
                            "id_product": 18,
                            "id_category": 1,
                            "title": "Сет Хот",
                            "price": "790",
                            "active": true,
                            "art": "",
                            "units": "2",
                            "discount": true,
                            "color": "1",
                            "description": "волк, восстание, хоккайдо, 24 шт., 1000 гр.",
                            "count": 1,
                            "deleted": "0",
                            "activity": true,
                            "name": "Сет Хот"
                        }
                    ],
                    "orderData": {
                        "id": "36",
                        "id_order": "41",
                        "id_user": "2",
                        "active": true,
                        "deleted": "0",
                        "date_create": "1655745899",
                        "id_klient": "4",
                        "comment": "",
                        "discountSale": "1",
                        "promokodeId": "0",
                        "sdacha": "4",
                        "typePayment": "1",
                        "ItogSumOrder": "1543",
                        "ItogSumOrderNoDiscount": "1715",
                        "sumDiscountOrder": "171"
                    },
                    "ItogSumOrder": "1543",
                    "klient": {
                        "id": "4",
                        "id_user": "2",
                        "id_organization": "0",
                        "firstName": "тест",
                        "lastName": null,
                        "phone": "792058576463",
                        "email": "test@email.com",
                        "birthday": "2022-06-09T15:22:38.632Z",
                        "birthdayText": "2022-6-9",
                        "comment": "Тестовый клиент, которого тут нет в базе",
                        "chanel": "4",
                        "active": true,
                        "deleted": "0",
                        "bonus_points": "0",
                        "edit": "1"
                    },
                    "delivered": {
                        "id": "36",
                        "id_user": "2",
                        "id_order": "41",
                        "id_affiliate": "1",
                        "pointOrderId": "4",
                        "timeDeliveredType": "1",
                        "typeDeliveredOrder": false,
                        "dateDeliveredText": "2022-6-20",
                        "dateDelivered": "2022-06-22T19:22:00.000Z",
                        "timeDeliveredText": "17:25",
                        "timeDelivered": "2022-06-20T14:25:52.907Z",
                        "dateSetOrder": "2022-06-20T17:24:59.000Z",
                        "active": false,
                        "adres": {
                            "id": "15",
                            "id_address": "11",
                            "id_user": "2",
                            "id_order": "41",
                            "city": "Белгород",
                            "street": "Садовая",
                            "home": "2",
                            "entrance": "3",
                            "floor": "3",
                            "apartament": "3",
                            "comment": "нкелклнр",
                            "active": true,
                            "deleted": "0",
                            "id_delivered": "36"
                        }
                    },
                    "marks": [
                        {
                            "id": "104",
                            "id_order": "41",
                            "id_marks": "23",
                            "name": "РЕКЛАМА",
                            "active": true,
                            "deleted": "0"
                        },
                        {
                            "id": "105",
                            "id_order": "41",
                            "id_marks": "18",
                            "name": "Ожидание 3-3,5 часа",
                            "active": true,
                            "deleted": "0"
                        }
                    ],
                    "memo": null,
                    "ItogSumOrderNoDiscount": "1715",
                    "sumDiscountOrder": "171",
                    "statusOrder": {
                        "id": "61",
                        "id_order": "41",
                        "id_worker": "0",
                        "id_account": "2",
                        "id_user": "2",
                        "id_status": "1",
                        "active": true,
                        "deleted": "0",
                        "type_status": "0",
                        "time_insert": "1655745899"
                    },
                    "statusOrderAll": [
                        {
                            "id": "61",
                            "id_order": "41",
                            "id_worker": "0",
                            "id_account": "2",
                            "id_user": "2",
                            "id_status": "1",
                            "active": true,
                            "deleted": "0",
                            "type_status": "0",
                            "time_insert": "1655745899"
                        }
                    ]
                }
            }
        }
    };

export default KlientOrdersInfo
